/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const utilitySelectorModule = require('@utils/utility_selector/utilitySelectorModule');
const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const swiftypeModule = require('@utils/swiftype/swiftypeModule');
const AccountAuthService = require('./accountAuthService');
const SignupService = require('./signupService');
const AccountSideNavService = require('./sideNav/sideNavService');
const FavProductsService = require('./favProducts/favProductsService');
const SolarService = require('./solar/solarService');
const SavedSearchesService = require('./savedSearches/savedSearchesService');

const accountModule = angular
    .module('enervee_utils.account', [
        commonModule.name,
        consumersModule.name,
        swiftypeModule.name,
        utilitySelectorModule.name,
    ])
    .factory('AccountAuthService', AccountAuthService)
    .factory('SignupService', SignupService)
    .factory('AccountSideNavService', AccountSideNavService)
    .factory('FavProductsService', FavProductsService)
    .factory('SolarService', SolarService)
    .factory('SavedSearchesService', SavedSearchesService);

module.exports = accountModule;
